// extracted by mini-css-extract-plugin
export default {"listColor":"Sidebar_listColor__8LuIl"};